module.exports = __webpack_public_path__ + "static/img/materialsInfo12.c7825ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/materialsInfo12.png
// module id = /8rF
// module chunks = 2